/* =============================================================================
   BULLION — collection.js  (collection + search templates)
   Facet filtering, sorting, load more — all via the Section Rendering API.
   ========================================================================== */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const MVS = window.MVS;
  const debounce = (fn, w = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), w); }; };

  class Facets extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.forms = $$('form[data-facets-form]', this);
      this.results = $('[data-facets-results]', this);
      this.forms.forEach(f => {
        f.addEventListener('input', debounce((e) => { if (e.target.type === 'number') return; this.submit(f); }, 150));
        f.addEventListener('change', debounce((e) => { if (e.target.type !== 'number') return; this.submit(f); }, 500));
        f.addEventListener('submit', (e) => { e.preventDefault(); this.submit(f); });
      });
      this.addEventListener('click', (e) => {
        const a = e.target.closest('[data-facet-remove], .pagination a');
        if (a) { e.preventDefault(); this.load(a.href, !!a.closest('.pagination')); }
        const lm = e.target.closest('[data-load-more]');
        if (lm) { e.preventDefault(); this.loadMore(lm); }
      });
      window.addEventListener('popstate', () => this.load(window.location.href, false, false));
    }
    submit(form) {
      const params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(k => { if (params.get(k) === '') params.delete(k); });
      const sort = $('[data-sort-select]', this);
      if (sort && sort.value && !params.has('sort_by')) params.set('sort_by', sort.value);
      const url = `${window.location.pathname}?${params.toString()}`;
      this.load(url);
    }
    async load(url, scroll = true, push = true) {
      if (!this.results) return;
      this.results.setAttribute('aria-busy', 'true');
      this.results.style.opacity = '0.45';
      try {
        const u = new URL(url, window.location.origin); u.searchParams.set('section_id', this.sectionId);
        const html = await (await fetch(u.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-facets-results]', doc);
        const freshForms = $$('form[data-facets-form]', doc);
        if (fresh) this.results.innerHTML = fresh.innerHTML;
        // sync facet forms (counts, checked states) without losing focus in price inputs
        this.forms.forEach((f, i) => { const nf = freshForms[i]; if (!nf) return; const active = document.activeElement; if (f.contains(active) && active.type === 'number') return; f.innerHTML = nf.innerHTML; });
        const count = $('[data-results-count]', doc); const target = $('[data-results-count]'); if (count && target) target.textContent = count.textContent;
        if (push) window.history.pushState({}, '', url);
        MVS.bindGlow && MVS.bindGlow(this.results); MVS.observeReveal && MVS.observeReveal(this.results); MVS.syncWishlist && MVS.syncWishlist(this.results);
        if (scroll) { const top = this.results.getBoundingClientRect().top + window.scrollY - 140; window.scrollTo({ top, behavior: 'smooth' }); }
      } catch (_) { window.location.href = url; }
      finally { this.results.removeAttribute('aria-busy'); this.results.style.opacity = ''; }
    }
    async loadMore(btn) {
      const next = btn.dataset.loadMore; if (!next) return;
      btn.classList.add('is-loading');
      try {
        const u = new URL(next, window.location.origin); u.searchParams.set('section_id', this.sectionId);
        const html = await (await fetch(u.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = $('[data-product-grid]', doc), target = $('[data-product-grid]', this);
        if (grid && target) Array.from(grid.children).forEach(c => target.appendChild(c));
        const freshLm = $('[data-load-more]', doc), wrap = btn.closest('.load-more');
        if (freshLm && wrap) wrap.outerHTML = freshLm.closest('.load-more').outerHTML; else if (wrap) wrap.remove();
        MVS.bindGlow && MVS.bindGlow(target); MVS.observeReveal && MVS.observeReveal(target); MVS.syncWishlist && MVS.syncWishlist(target);
        window.history.replaceState({}, '', next.replace(/&?section_id=[^&]*/, ''));
      } catch (_) { window.location.href = next; }
      finally { btn.classList.remove('is-loading'); }
    }
  }
  customElements.define('facet-filters', Facets);

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sort-select]'); if (!sel) return;
    const facets = sel.closest('facet-filters');
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
    facets ? facets.load(url.pathname + url.search) : (window.location.href = url.toString());
  });
})();
